import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { IOnoffable, PoolDeviceInterface } from "../Interfaces";
import { DisplayProcessingLogics, PoolDeviceCriticalDesiredActual } from "../Types";
import Locale from "../../utils/Locale";
import PoolDeviceOnOffable from "./base-onoffable";

export enum criticalFieldIdentifiers {
    OnOff = "OnOff",
}

export default class PoolDeviceChemicalPump extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable {
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.CHEMICALPUMP;
    static Icon = "laboratory-glassware";
    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    static PickerTitle = Locale.gettext("Chemical Pump");

    getCriticalFields():PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }
    
        return fields;
    }
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    PowerState = "PowerState",
}
